// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uKiC2","textarea":"styles_textarea__3co9s"};